import React from 'react';
import { useNavigate } from "react-router-dom";
import { GridColumnMenuFilter } from '@progress/kendo-react-grid';
import { SpheraTooltip } from "@sphera-cloud/component-ui-reactjs";
import { Grid, GridColumn as Column, GridColumnMenuWrapper } from "@progress/kendo-react-grid";
import { LoadingPanel } from '../LoadingPanel';
import { TextCell } from './Cell/TextCell';
import dateFormats from "../../Data/dateFormats.json";
import { CustomColumnMenu } from "../CustomColumnMenu";

export function DocumentGrid(props) {
    const navigate = useNavigate();
    const searchedPhrase = props.searchedPhrase;
    const [dateFormat, setdateFormat] = React.useState("{0:dd/MM/yyyy hh:mm a}");
    const [dateFormatFilter, setdateFormatFilter] = React.useState("dd/MM/yyyy hh:mm a");

    const linkClick = (materialId) => {
        localStorage.removeItem("sphdsSearchPhrase");
        localStorage.setItem("sphdsSearchPhrase", searchedPhrase);
        navigate("/material/" + materialId + "?fromSearch=true" + (props.searchArchive ? "&searchArchive=true" : ""));
    }

    React.useEffect(() => {
        if (props.dateFormatId != null) {
            let format = dateFormats.find(x => x.value === props.dateFormatId);
            if (format != null) {
                setdateFormat("{0:" + format.text + " hh:mm a}");
                setdateFormatFilter(format.text + " hh:mm a");
            }
        }
    }, [props.dateFormatId]);

    return (
        <div style={{ height: 'calc(100vh - 325px)', minHeight: '300px' }} className={!(props.currentTenent.RequiresNavMenu) ? 'gridAddMargin' : ''}>
            <Grid
                className="sphera-grid"
                style={{
                    height: '100%',
                    width: '100%'
                }}
                data={props.dataResult}
                {...props.dataState}
                onDataStateChange={props.dataStateChange}
                sortable={true}
                resizable={true}
                scrollable="scrollable"
                pageable={{
                    buttonCount: 4,
                    pageSizes: [25, 50, 100]
                }}
            >
                {(props.customer.columns && props.customer.columns.materialColumns) && props.customer.columns.materialColumns.map(
                    (column, idx) =>
                        column.show && (
                            <Column
                                key={idx}
                                cell={ (props2) =>
                                    <TextCell field={column.field}
                                        isLink={column.IsLink}
                                        searchedPhrase={searchedPhrase}
                                        linkClick={linkClick}
                                        clickId={props2.dataItem.materialId}
                                        DisplayValue={column.AdjustTimezone || column.field.indexOf("Tag") > -1 || column.IsList === "true" ? props2.dataItem[column.field + "Display"] : props2.dataItem[column.field]}
                                        customer={props.customer}
                                        isDate={column.IsDate}
                                        adjustTimezone={column.AdjustTimezone}
                                    />
                                }
                                field={column.field}
                                width={column.width}
                                minResizableWidth={100}
                                title={column.Title}
                                filterable={column.Filter !== "false" || column.field.indexOf("Tag") > -1 }
                                sortable={column.Filter !== "false"}
                                filter={column.Filter !== "false" ? column.Filter : "text"}
                                format={dateFormat}
                                headerCell={(props2) => {
                                    if (column.Filter === "false" && column.field.indexOf("Tag") === -1)
										return (
                                            <span className="k-cell-inner">
                                                <span className="k-link" onClick={props2.onClick} onKeyDown={(e) => { if (e.code === "Enter") props2.onClick(); }}>
                                                    <SpheraTooltip anchor="target" position="top" title={column.Title} >
                                                        <span className="k-column-title">{column.Title}</span>
                                                    </SpheraTooltip>
                                                    {props2.children}
                                                </span>
                                            </span>);
                                    return (<span className="k-cell-inner">
                                        <span className="k-link" onClick={props2.onClick} onKeyDown={(e) => { if (e.code === "Enter") props2.onClick(); }}>
                                            <SpheraTooltip anchor="target" position="top" title={column.Title} >
                                                <span className="k-column-title">{column.Title}</span>
                                            </SpheraTooltip>
                                            {props2.children}
                                        </span>
                                        <GridColumnMenuWrapper
                                            {...props2.columnMenuWrapperProps}
                                        ></GridColumnMenuWrapper>
                                    </span>);
                                }
                                }
                                headerClassName={GridColumnMenuFilter.active(column.field, props.dataState.filter) ? 'active' : ''}
                                columnMenu={(props2) => {
                                    return column.Filter === "false" && column.field.indexOf("Tag") === -1 ? null : <CustomColumnMenu {...props2} columns={props.customer.columns.materialColumns} useDateFilter={column.IsDate} dateFormatFilter={dateFormatFilter} />
                                }}
                            />
                        )
                )}
            </Grid>
            {props.pending && <LoadingPanel localizations={props.localizations} />}
        </div>
    );
}